import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import * as React from 'react';
// @mui
import {
  Container,
  Typography,
  Stack,
  Button,
  Tabs,
  Tab,
  Box,
} from '@mui/material';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { UserListToolbar } from '../sections/@dashboard/user';
import Iconify from '../components/iconify';
import AddKit from './AddKit';
import AddKitBombeamento from './AddKitBombeamento';
import AddKitOffGrid from './AddKitOffGrid';

// api
import { validateUser, getKits, updateKit, getKitsOffGrid } from './api';
import config from '../config.json';
import PopoverFiltroKit from './PopoverFiltroKit';

// ----------------------------------------------------------------------

// Componente de aba vazia (Grid-Zero, Off-Grid, Bombeamento)
function AbaEmConstrucao({ titulo, onAdd }) {
  return (
    <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
      <Typography variant="h6" color="text.secondary">
        {titulo}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Nenhum kit cadastrado ainda.
      </Typography>
      <Button
        variant="contained"
        startIcon={<Iconify icon="zondicons:add-solid" />}
        onClick={onAdd}
        sx={{ height: 50 }}
      >
        Adicionar Kit
      </Button>
    </Box>
  );
}

// ----------------------------------------------------------------------

export default function Kits() {
  const [rowsKits, setRowsKits] = useState([]);
  const [rowsKitsOffGrid, setRowsKitsOffGrid] = useState([]);
  const [abaAtiva, setAbaAtiva] = useState(0);
  const isSupervisor = JSON.parse(localStorage.getItem('userData'))?.supervisor;

  useEffect(() => { fGetKits(); }, []);

  const fGetKits = (aba = abaAtiva) => {
    if (aba === 2) {
      // Aba Off-Grid — usa endpoint próprio
      getKitsOffGrid()
        .then((dados) => { setRowsKitsOffGrid(Array.isArray(dados) ? dados : []); })
        .catch((error) => {
          window.alert('Erro ao consultar kits off-grid');
          console.error(error);
        });
      return;
    }
    const filtroComTipo = aba === 3
      ? { ...filtro, tipokat: 'bombeamento' }
      : { ...filtro };
    getKits(filtroComTipo)
      .then((dados) => { setRowsKits(dados); })
      .catch((error) => {
        window.alert('Erro ao consultar banco de dados');
        console.error('Erro ao buscar dados da API:', error);
      });
  };

  // Valida usuario
  const navigate = useNavigate();
  useEffect(() => { validateuser(); }, []);
  const validateuser = async () => {
    const teste = await validateUser();
    if (!teste.ok) {
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {};
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente');
      return;
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario;
  };

  // Modal
  const [open, setOpen] = React.useState(false);
  const [produto, setProduto] = React.useState(null);
  const handleOpen = () => setOpen(true);

  const [openBombeamento, setOpenBombeamento] = React.useState(false);
  const [produtoBombeamento, setProdutoBombeamento] = React.useState(null);

  const [openOffGrid, setOpenOffGrid] = React.useState(false);
  const [produtoOffGrid, setProdutoOffGrid] = React.useState(null);

  const [openFiltro, setOpenFiltro] = useState(null);
  const [filtro, setFiltro] = useState({});

  const handleClose = () => {
    setOpen(false);
    setProduto(null);
  };

  const onConfirmHandler = async (updatedProduto) => {
    const result = await updateKit(updatedProduto);
    handleClose();
    window.alert(result.msg);
    fGetKits();
  };

  const onConfirmBombeamento = async (updatedProduto) => {
    const result = await updateKit(updatedProduto);
    setOpenBombeamento(false);
    setProdutoBombeamento(null);
    window.alert(result.msg);
    fGetKits();
  };

  const handleDoubleClickTable = (row, index) => {
    const usuario = JSON.parse(localStorage.getItem('userData'));
    if (!usuario.supervisor) {
      window.alert('Sem Acesso Para Alteração');
      return;
    }
    if (row.tipokat === 'bombeamento') {
      setProdutoBombeamento({ ...row, index });
      setOpenBombeamento(true);
    } else if (row.tipokat === 'offgrid') {
      setProdutoOffGrid({ ...row, index });
      setOpenOffGrid(true);
    } else {
      setProduto({ ...row, index });
      setOpen(true);
    }
  };

  const onConfirmFiltro = (filtroPopover) => { setFiltro(filtroPopover); };

  useEffect(() => { fGetKits(); }, [filtro]);

  // Filtro tabela
  const [filterValue, setFilterValue] = useState('');
  const filtered = rowsKits.filter((row) => {
    const filterValueLower = filterValue.toLowerCase();
    return (
      row.nome?.toLowerCase().includes(filterValueLower) ||
      (row.quantidademodulos !== undefined && row.quantidademodulos.toString().includes(filterValueLower)) ||
      (row.potenciacc !== undefined && row.potenciacc.toString().includes(filterValueLower))
    );
  });

  const handleFilter = (event) => { setFilterValue(event.target.value); };

  const handleChangeAba = (event, novaAba) => { setAbaAtiva(novaAba); fGetKits(novaAba); };

  return (
    <>
      <Helmet>
        <title> Kits </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h4" sx={{ mb: 3 }}>
            Kits
          </Typography>

          {/* Botões de ação — só aparecem na aba On-Grid */}
          {abaAtiva === 0 && (
            <Stack direction="row" gap={2}>
              <Button
                onClick={(e) => setOpenFiltro(e.currentTarget)}
                variant="contained"
                startIcon={<Iconify icon="eva:search-fill" />}
                sx={{ height: 50, minWidth: 25, backgroundColor: 'MediumSeaGreen', '&:hover': { backgroundColor: 'SeaGreen' } }}
              />
              <Button
                variant="contained"
                startIcon={<Iconify icon="zondicons:add-solid" />}
                onClick={handleOpen}
                sx={{ height: 50, minWidth: 100 }}
              >
                Adicionar
              </Button>
            </Stack>
          )}
        </Stack>

        {/* Abas */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs
            value={abaAtiva}
            onChange={handleChangeAba}
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab label="Kits On-Grid" />
            <Tab label="Kits Grid-Zero" />
            <Tab label="Kits Off-Grid" />
            <Tab label="Kits Bombeamento" />
          </Tabs>
        </Box>

        {/* Aba On-Grid */}
        {abaAtiva === 0 && (
          <>
            <UserListToolbar filterName={filterValue} onFilterName={handleFilter} sx={{ width: '80vw' }} />

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="kits on-grid">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Nome</TableCell>
                    <TableCell align="center">Módulos</TableCell>
                    <TableCell align="center">Potência Individual</TableCell>
                    <TableCell align="center">Potência CC</TableCell>
                    <TableCell align="center">Potência Inversor</TableCell>
                    <TableCell align="center">Disjuntor Mínimo</TableCell>
                    {isSupervisor && <TableCell align="center">Desconto Máximo</TableCell>}
                    <TableCell align="right">Venda (à Vista)</TableCell>
                    <TableCell align="right">Venda (Cartão)</TableCell>
                    {isSupervisor && <TableCell align="right">Margem Lucro</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filtered.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { backgroundColor: 'Azure' } }}
                      onDoubleClick={() => handleDoubleClickTable(row, index)}
                    >
                      <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>{row.nome}</TableCell>
                      <TableCell align="center">{row.quantidademodulos}</TableCell>
                      <TableCell align="center">{row.modulo?.potencia || '-'}</TableCell>
                      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>{row.potenciacc} kWp</TableCell>
                      <TableCell align="center">{row.potenciainversor}</TableCell>
                      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                        {row.disjuntorminino?.tipodisjuntor?.nome
                          ? `${row.disjuntorminino.tipodisjuntor.nome} ${row.disjuntorminino.potenciadisjuntor.valor}A`
                          : '-'}
                      </TableCell>
                      {isSupervisor && <TableCell align="center">{row.descontomaximo}</TableCell>}
                      <TableCell align="right">
                        {typeof row.precovenda === 'number'
                          ? row.precovenda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                          : '-'}
                      </TableCell>
                      <TableCell align="right">
                        {row.valorcartao
                          ? row.valorcartao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                          : '-'}
                      </TableCell>
                      {isSupervisor && <TableCell align="right">
                        {row.margemlucro != null ? `${row.margemlucro}%` : '-'}
                      </TableCell>}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}

        {/* Aba Grid-Zero */}
        {abaAtiva === 1 && (
          <AbaEmConstrucao titulo="Kits Grid-Zero" onAdd={handleOpen} />
        )}

        {/* Aba Off-Grid */}
        {abaAtiva === 2 && (
          rowsKitsOffGrid.length === 0 ? (
            <AbaEmConstrucao titulo="Kits Off-Grid" onAdd={() => setOpenOffGrid(true)} />
          ) : (
            <>
              <Stack direction="row" justifyContent="flex-end" mb={2}>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="zondicons:add-solid" />}
                  onClick={() => { setProdutoOffGrid(null); setOpenOffGrid(true); }}
                  sx={{ height: 50, minWidth: 100 }}
                >
                  Adicionar
                </Button>
              </Stack>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="kits off-grid">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Nome</TableCell>
                      <TableCell align="center">Módulos</TableCell>
                      <TableCell align="center">Potência CC</TableCell>
                      <TableCell align="center">Inversor</TableCell>
                      <TableCell align="center">Bateria</TableCell>
                      <TableCell align="center">Autonomia (kWh)</TableCell>
                      {isSupervisor && <TableCell align="center">Desconto Máximo</TableCell>}
                      <TableCell align="right">Venda (à Vista)</TableCell>
                      <TableCell align="right">Venda (Cartão)</TableCell>
                      {isSupervisor && <TableCell align="right">Margem Lucro</TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowsKitsOffGrid.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { backgroundColor: 'Azure' } }}
                        onDoubleClick={() => handleDoubleClickTable(row, index)}
                      >
                        <TableCell align="left">{row.nome}</TableCell>
                        <TableCell align="center">{row.quantidademodulos || row.modulo?.qtde || '—'}</TableCell>
                        <TableCell align="center">{row.potenciacc} kWp</TableCell>
                        <TableCell align="center">{row.inversor?.modelo || '—'}</TableCell>
                        <TableCell align="center">{row.bateria?.modelo || '—'}</TableCell>
                        <TableCell align="center">
                          {row.autonomia != null ? `${row.autonomia} kWh` : '—'}
                        </TableCell>
                        {isSupervisor && <TableCell align="center">{row.descontoMaximo ?? '—'}</TableCell>}
                        <TableCell align="right">
                          {typeof row.precovenda === 'number'
                            ? row.precovenda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                            : '—'}
                        </TableCell>
                        <TableCell align="right">
                          {row.valorcartao
                            ? row.valorcartao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                            : '—'}
                        </TableCell>
                        {isSupervisor && (
                          <TableCell align="right">
                            {row.margemlucro != null ? `${row.margemlucro}%` : '—'}
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )
        )}

        {/* Aba Bombeamento */}
        {abaAtiva === 3 && (
          rowsKits.length === 0 ? (
            <AbaEmConstrucao titulo="Kits Bombeamento" onAdd={() => setOpenBombeamento(true)} />
          ) : (
            <>
              <Stack direction="row" justifyContent="flex-end" mb={2}>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="zondicons:add-solid" />}
                  onClick={() => setOpenBombeamento(true)}
                  sx={{ height: 50, minWidth: 100 }}
                >
                  Adicionar
                </Button>
              </Stack>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="kits bombeamento">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Nome</TableCell>
                      <TableCell align="center">Módulos</TableCell>
                      <TableCell align="center">Potência CC</TableCell>
                      <TableCell align="center">Inversor</TableCell>
                      <TableCell align="center">Potência Inv. (CV)</TableCell>
                      {isSupervisor && <TableCell align="center">Desconto Máximo</TableCell>}
                      <TableCell align="right">Venda (à Vista)</TableCell>
                      <TableCell align="right">Venda (Cartão)</TableCell>
                      {isSupervisor && <TableCell align="right">Margem Lucro</TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowsKits.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { backgroundColor: 'Azure' } }}
                        onDoubleClick={() => handleDoubleClickTable(row, index)}
                      >
                        <TableCell align="left">{row.nome}</TableCell>
                        <TableCell align="center">{row.quantidademodulos}</TableCell>
                        <TableCell align="center">{row.potenciacc} kWp</TableCell>
                        <TableCell align="center">{row.inversor?.modelo || '-'}</TableCell>
                        <TableCell align="center">{row.potenciainversor} CV</TableCell>
                        {isSupervisor && <TableCell align="center">{row.descontomaximo}</TableCell>}
                        <TableCell align="right">
                          {typeof row.precovenda === 'number'
                            ? row.precovenda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                            : '-'}
                        </TableCell>
                        <TableCell align="right">
                          {row.valorcartao
                            ? row.valorcartao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                            : '-'}
                        </TableCell>
                        {isSupervisor && (
                          <TableCell align="right">
                            {row.margemlucro != null ? `${row.margemlucro}%` : '-'}
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )
        )}

        {/* Modal Add */}
        {open && (
          <AddKit open={open} produto={produto} onClose={handleClose} onConfirm={onConfirmHandler} />
        )}

        {openBombeamento && (
          <AddKitBombeamento
            open={openBombeamento}
            produto={produtoBombeamento}
            onClose={() => { setOpenBombeamento(false); setProdutoBombeamento(null); }}
            onConfirm={onConfirmBombeamento}
          />
        )}

        {openOffGrid && (
          <AddKitOffGrid
            open={openOffGrid}
            produto={produtoOffGrid}
            onClose={() => { setOpenOffGrid(false); setProdutoOffGrid(null); }}
            onConfirm={() => { setOpenOffGrid(false); setProdutoOffGrid(null); fGetKits(2); }}
          />
        )}

        {openFiltro && (
          <PopoverFiltroKit
            filtro={filtro}
            open={openFiltro}
            onClose={() => setOpenFiltro(null)}
            onConfirm={onConfirmFiltro}
          />
        )}

      </Container>
    </>
  );
}